export class FormStateModel<T> {
    model: T = undefined;
    dirty = false;
    status = '';
    errors: T = null;
    constructor() {}
}
